export enum PartnersState {
    welcome,
    information,
    finish
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/PartnersState.ts